module.exports = __webpack_public_path__ + "static/media/ACC.20b3e4e1.txt";